module.exports = __webpack_public_path__ + "img/logo.b0182bd8.png";